import { catchError, filter, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ScannableToScanConfig } from '@ng-cloud/badger-core/models/scannable-to-scan-config';

@Injectable()
export class ScannableToScanConfigService extends ApiService {

  /**
   * Fetch all ScanConfigTypes
   */
  listScannableToScanConfigs(organizationId: number, params?: any): Observable<ScannableToScanConfig[]> {
    let url = `organizations/${organizationId}/scannable_to_scan_configs`;
    return this.list(ScannableToScanConfig, url, params);
  }
}
